/*
 * @Author: Christion.Young
 * @Date: 2025-08-08 10:00:00
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-08 10:00:00
 * @Description: 权限工具 - 简化版
 */

/**
 * 登录检查指令
 * 用法：v-login-required
 */
export const loginRequired = {
  inserted(el, binding, vnode) {
    const store = vnode.context.$store;
    const isLoggedIn = store.getters["user/isLoggedIn"];

    if (!isLoggedIn) {
      el.style.display = "none";
    }
  },

  update(el, binding, vnode) {
    const store = vnode.context.$store;
    const isLoggedIn = store.getters["user/isLoggedIn"];

    if (!isLoggedIn) {
      el.style.display = "none";
    } else {
      el.style.display = "";
    }
  },
};

/**
 * 简化权限混入
 * 提供组件内的基础权限检查方法
 */
export const permissionMixin = {
  methods: {
    /**
     * 检查是否已登录
     * @returns {boolean} 是否已登录
     */
    $isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },

    /**
     * 获取当前用户信息
     * @returns {Object} 用户信息
     */
    $getCurrentUser() {
      return this.$store.getters["user/userInfo"];
    },

    /**
     * 需要登录时的处理
     * @param {string} redirectPath - 登录成功后的重定向路径
     */
    $requireLogin(redirectPath = null) {
      this.$bus.emit("show-login-dialog", {
        redirectPath: redirectPath || this.$route.fullPath,
      });
    },

    /**
     * 登录状态提示
     * @param {string} message - 提示信息
     */
    $showLoginRequired(message = "请先登录") {
      this.$msg.warning(message);
      this.$requireLogin();
    },
  },
};

/**
 * 安装简化权限系统
 * @param {Object} Vue - Vue构造函数
 */
export function install(Vue) {
  // 注册指令
  Vue.directive("login-required", loginRequired);

  // 全局混入权限方法
  Vue.mixin(permissionMixin);
}

export default {
  install,
  loginRequired,
  permissionMixin,
};
